import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { Sidebar } from './components/layout/Sidebar'
import Login from './pages/Login'
import Register from './pages/Register'
import Acceder from './pages/Acceder'
import Pricing from './pages/Pricing'
import Onboarding from './pages/Onboarding'
import Dashboard from './pages/Dashboard'
import Clientes from './pages/Clientes'
import ClienteDetalle from './pages/ClienteDetalle'
import Ejecuciones from './pages/Ejecuciones'
import SLA from './pages/SLA'
import Alertas from './pages/Alertas'
import Embudo from './pages/Embudo'
import CifrasLandingPage from './pages/CifrasLanding'
import Uso from './pages/Uso'
import Prospeccion from './pages/Prospeccion'
import RadarCa from './pages/RadarCa'
import InformeSlaPrint from './pages/InformeSlaPrint'
import BillingSettings from './pages/BillingSettings'
import Configuracion from './pages/Configuracion'
import FlowCallback from './pages/FlowCallback'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import { useSchedulerJobs } from './hooks/useScraping'

/* Las ejecuciones de un cliente se plegaron en su ficha (28-08): la ruta
   vieja redirige a la pestaña — la apuntan alertas, tablas y enlaces
   guardados, y un 404 silencioso es peor que una redirección. */
function ScrapingRedirige() {
  const { clienteId } = useParams()
  return <Navigate to={`/clientes/${clienteId}?pestana=ejecuciones`} replace />
}

function AppLayout() {
  const { data: schedulerData, isLoading: cargandoJobs } = useSchedulerJobs()
  // ⚠️ Era `schedulerData?.jobs?.length ?? 0`. Con la petición caída daba 0, y
  // la barra lateral anunciaba «Scheduler inactivo» — afirmando que la máquina
  // está parada cuando lo único cierto es que no se pudo preguntar. `null` =
  // no se sabe, y el Sidebar lo dice con esas palabras.
  const activeJobs = Array.isArray(schedulerData?.jobs) ? schedulerData.jobs.length : null
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar activeJobs={activeJobs} cargando={cargandoJobs} />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minWidth: 0 }}>
        <Routes>
          <Route path="/"                    element={<Dashboard />} />
          <Route path="/clientes"            element={<Clientes />} />
          <Route path="/clientes/:id"        element={<ClienteDetalle />} />
          <Route path="/ejecuciones/:clienteId" element={<ScrapingRedirige />} />
          <Route path="/sla"                 element={<SLA />} />
          <Route path="/ejecuciones"         element={<Ejecuciones />} />
          {/* Actividad y Programación se fundieron en Ejecuciones (fase 3).
              Las rutas viejas redirigen en vez de desaparecer: hay enlaces
              guardados, y un 404 silencioso es peor que una redirección. */}
          <Route path="/actividad"           element={<Navigate to="/ejecuciones" replace />} />
          <Route path="/scheduler"           element={<Navigate to="/ejecuciones" replace />} />
          {/* Retirada en la fase 4: el convenio es un dato del cliente y una
              columna con filtro en su lista, no una pantalla propia. */}
          <Route path="/familias"            element={<Navigate to="/clientes" replace />} />
          <Route path="/alertas"             element={<Alertas />} />
          <Route path="/embudo"              element={<Embudo />} />
          {/* Salió del fondo de Estado a página propia (27-08): un dato que
              decide si la web dice la verdad no puede exigir bajar un parte. */}
          <Route path="/cifras-landing"      element={<CifrasLandingPage />} />
          <Route path="/uso"                 element={<Uso />} />
          <Route path="/radar-ca"            element={<RadarCa />} />
          <Route path="/prospeccion"         element={<Prospeccion />} />
          <Route path="/settings/billing"    element={<BillingSettings />} />
          <Route path="/settings/cuenta"     element={<Configuracion />} />
          <Route path="*"                    element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"      element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/acceder" element={<Acceder />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/pricing"    element={<Pricing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/billing/flow-callback" element={<FlowCallback />} />
      {/* Vista imprimible del informe SLA: protegida pero sin el shell del panel
          (sin sidebar) para que el PDF salga como documento limpio */}
      <Route path="/sla/informe/print" element={
        <ProtectedRoute>
          <InformeSlaPrint />
        </ProtectedRoute>
      } />
      <Route path="/*" element={
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      } />
    </Routes>
  )
}
